import FixaButton from "@coworker/apprestructured/src/shared/wrappers/FixaButton/FixaButton";
import {
  FixaAccordion,
  FixaAccordionItem,
} from "@coworker/apprestructured/src/shared/wrappers/FixaAccordion/FixaAccordion";
import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import LinkOutIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/LinkOutIconPath";
import styles from "./unauthorizedpage.module.css";
import { useTranslation } from "@coworker/locales";
const roleTypesContext = {
  coworker: {
    translationKey: "unauthorizedCoworkerDisclaimerTitleString",
    myIdentityLink:
      "https://myidentity.apps.ikea.com/IdentityManager/page.axd?ContextID=VI_ITShop_ProductSelection&uid_accproduct=9cc420f7-a2a8-427c-9582-aa43446ef290",
  },
  storeSuperUser: {
    translationKey: "unauthorizedStoreSuperUserDisclaimerTitleString",
    myIdentityLink:
      "https://myidentity.apps.ikea.com/IdentityManager/page.axd?ContextID=VI_ITShop_ProductSelection&uid_accproduct=14c52d7b-ce0e-4f2a-984b-d585a523664a",
  },
  countrySuperUser: {
    translationKey: "unauthorizedCountrySuperUserDisclaimerTitleString",
    myIdentityLink:
      "https://myidentity.apps.ikea.com/IdentityManager/page.axd?ContextID=VI_ITShop_ProductSelection&uid_accproduct=befa0173-d693-447d-965c-28e21f92247b",
  },
};

type RoleTypeKey = keyof typeof roleTypesContext;

interface UnauthorizedPageAccordionProps {
  roleTypes?: RoleTypeKey[];
  title?: string;
  description?: string;
}

const UnauthorizedPageAccordion = ({
  roleTypes,
  title,
  description,
}: UnauthorizedPageAccordionProps = {}) => {
  const { t } = useTranslation();
  return (
    <div>
      {(title || description) && (
        <div className={styles["header-section"]}>
          {title && (
            <FixaText tagName="h1" textStyle="Heading.L">
              {title}
            </FixaText>
          )}
          {description && (
            <FixaText
              tagName="p"
              textStyle="Body.M"
              className={styles["header-description"]}
            >
              {description}
            </FixaText>
          )}
        </div>
      )}
      <div className={styles["faq-section"]}>
        <FixaAccordion padded>
          {Object.entries(roleTypesContext)
            .filter(
              ([key]) => !roleTypes || roleTypes.includes(key as RoleTypeKey)
            )
            .map(([key, { translationKey, myIdentityLink }]) => (
              <FixaAccordionItem
                key={key}
                id={`unauthorized-${key}`}
                title={t(translationKey)}
              >
                <div className={styles["accordion-item-content"]}>
                  <FixaText tagName="p" textStyle="Body.M">
                    {t("unauthorizedDisclaimerBodyString")}
                    <b> My Identity.</b>
                  </FixaText>
                  <FixaButton
                    type="primary"
                    fluid
                    ssrIcon={LinkOutIconPath}
                    iconPosition="trailing"
                    text={t("requestAccessString")}
                    onClick={() =>
                      window.open(
                        myIdentityLink,
                        "_blank",
                        "noopener,noreferrer"
                      )
                    }
                  />
                </div>
              </FixaAccordionItem>
            ))}
        </FixaAccordion>
      </div>
    </div>
  );
};

export default UnauthorizedPageAccordion;
